
<template>
    <div class="infoContent">
       

        <div class="rulet" @click="goRules">
            <img src="../../../../assets/img/w.png" />
            规则说明
        </div>
        <div class="suject">
            <div class="suject-t"><i class="tj">*</i> 您对本次搜索结果满意吗？</div>
            <van-radio-group v-model="radio" direction="horizontal">
                <van-radio name=3>满意&ensp;&ensp;</van-radio>
                <van-radio name=0>不满意</van-radio>
            </van-radio-group>
        </div>
      <div v-if="radio!=3&&radio!=''">
        <div class="suject">
            <div class="suject-t"><i class="tj">*</i> 整体评价</div>
            <ul class="uls">
                <li class="lis" @click="chooseFn(0)">
                    <p class="imgc" :class="searchResult==0?'imgc1p':'imgc1'"></p>
                    <p class="imgc-t">一般</p>
                </li>
                <li class="lis"  @click="chooseFn(1)">
                    <p class="imgc" :class="searchResult==1?'imgc2p':'imgc2'"></p>
                    <p class="imgc-t">较差</p>
                </li>
                <li class="lis"  @click="chooseFn(2)">
                    <p class="imgc" :class="searchResult==2?'imgc3p':'imgc3'"></p>
                    <p class="imgc-t">抓狂</p>
                </li>
            </ul>
        </div>

        <div class="suject" style="margin-bottom: 1rem;">
            <div class="suject-t"><i class="tj">*</i> 反馈类型</div>
            <van-checkbox-group direction="horizontal" v-model="reason">
                <van-checkbox shape="square" name=1>缺乏品牌&ensp;&ensp;</van-checkbox>
                <van-checkbox shape="square" name=2>缺少型号</van-checkbox>
                <van-checkbox shape="square" name=3>价格过高&ensp;&ensp;</van-checkbox>
                <van-checkbox shape="square" name=6>排序不合理</van-checkbox>
                <van-checkbox shape="square" name=7>页面卡顿&ensp;&ensp;</van-checkbox>
                <van-checkbox shape="square" name=5>筛选条件不佳</van-checkbox>
                <van-checkbox shape="square" name=8>结果不准确</van-checkbox>
                <van-checkbox shape="square" name=9>其它</van-checkbox>
            </van-checkbox-group>
        </div>
        <div class="suject sujecte" style="margin-bottom: 1rem;">
            <div class="suject-t"><i class="tj">*</i> 您的身份</div>
            <van-radio-group v-model="role" direction="horizontal">
                <van-radio name=1>采购&ensp;&ensp;</van-radio>
                <van-radio name=2>项目经理</van-radio>
                <van-radio name=3>技术人员</van-radio>
                <van-radio name=4>设计师</van-radio>
                <van-radio name=5>合作伙伴</van-radio>
                <van-radio name=6>老板</van-radio>
            </van-radio-group>
        </div>

        <div class="suject sujecte" style="margin-bottom: 1rem;">
            <div class="suject-t">详细描述</div>
            <van-field
                v-model="desc"
                type="textarea"
                placeholder="请输入详细描述，我们将尽快为您提供帮助！"
                />
        </div>
     </div>
     <van-button v-if="radio==3||radio==''" type="info" :disabled="radio!=3" block @click="submit()">提交</van-button>
     <van-button v-if="radio!=3&&radio!=''" type="info" :disabled="reasonLength" block @click="submit()">提交</van-button>
    </div>

</template>
<script>
import { getFeedback} from '../../../../request/search'
    export default{
       data(){
         return{
            radio:"",
            searchResult:0,
            reason:[],
            role:"",
            desc:"",
         }
       },
       computed:{
         reasonLength(){
          //  return this.reason.length>0?false:true
          if(this.reason.length>0&&this.role!=""){
              return false
          }else{
              return true
          }
        }
       },
       methods: {
        goRules(){
                 this.$emit("goRules",2)
            },

        chooseFn(val){
            this.searchResult = val;
            console.log("ooo==>",this.reason)
        },
        submit(){
            let arg;
            if(this.radio==3){
                 arg = {
                "searchResult": +this.radio,
                "keyword":$HMD$.rParam('k')||""
              }

            }else{
                 arg = {
                "desc": this.desc,
                "reason": this.reason,
                "role": this.role,
                "searchResult": this.searchResult,
                "keyword":$HMD$.rParam('k')||""
              }
            }
           console.log("arg--->",arg)
           getFeedback(arg).then(res=>{
               //console.log("iiiii===>",res)
               let data = res.data
               if(data.respCode=='0000'){
                  if(data.data){
                    this.$emit('goListEvt',true)
                  }else{
                    this.$toast('提交成功，感谢您的反馈！');
                    this.$emit('goListEvt',false)
                  }
               }

           }).catch(err=>{
             console.log(err)
           })
        }
       },
    }

</script>

<style lang="less" scoped>
   .infoContent{
     padding: 1.4rem 3.2rem;
    .rulet{
        text-align: right;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #2F7BFF;
        line-height: 20px;
        img{
            width: 1.67rem;
            height: 1.67rem;
            vertical-align: sub;
        }
    }
    .suject{
         margin-bottom: 1.8rem;
        .suject-t{
            font-size: 1.4rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #1E1F22;
            line-height: 2;
            margin-bottom:0.8rem;
          .tj{
            color: #F4333C;
          }
          .my{
            font-size: 2rem;
          }
        }
        .uls{
            display: flex;
            .lis{
                margin-right: 4.2rem;
            }
            .imgc{
               width:5rem;
               height: 5rem;
               margin-bottom:0.6rem ;
               background-repeat: no-repeat;
               background-position: center;
               background-size: cover; 
            }
            .imgc1{
                background-image: url(../../../../assets/img/1.png) ;
            }
            .imgc1p{
                background-image: url(../../../../assets/img/1p.png) ;
            }
            .imgc2{
                background-image: url(../../../../assets/img/2.png) ;
            }
            .imgc2p{
                background-image: url(../../../../assets/img/2p.png) ;
            }
            .imgc3{
                background-image: url(../../../../assets/img/3.png) ;
            }
            .imgc3p{
                background-image: url(../../../../assets/img/3p.png) ;
            }
            .imgc-t{
                width:6rem;
                text-align: center;
                font-size: 1.6rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #888888;
                line-height: 1.8rem;
            }
        }
        
    }

   }
</style>